module.exports = __webpack_public_path__ + "00f77881e0006149eaa79e01581305bb.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/destructive_abilities-768.webp.png
// module id = 256
// module chunks = 0